import * as React from "react";
import {css} from "/src/utils/utils";
import * as styles from "./loop-dot.module.scss";

interface Props {
  isActive: boolean;
  position: string;
  onClick: () => void;
}

export function LoopDot(props: Props) {
  const {isActive, position, onClick} = props;
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      className={css(
        styles.loopDot,
        styles[
          `loopDot${position.charAt(0).toUpperCase()}${position.slice(1)}`
        ],
        isActive ? styles.loopDotIsActive : ""
      )}
    />
  );
}
